import request from '../../axios';

interface InputGroup {
  guid: string;
  title: string;
  title_description: string | null;
  code: number;
  icon?: string;
  image?: string;
}

export interface IInputs {
  guid: string;
  code: number;
  title: string;
  image: string;
  input_group: InputGroup;
}

const getStoreInputs = async (storeGuid?: string, input_group?: number) => {
  const {data}: {data: IInputs[]} = await request.get(
    `/api/v2/store/list-store-input/${storeGuid}`,
    {params: {input_group}},
  );

  return data;
};

export default getStoreInputs;
